import {
  queryOptions,
  useQueryClient,
  useMutation as useReactQueryMutation,
} from '@tanstack/react-query';

import { chuteSchedulerApi } from './api';
import { BulkRevisionUpdateInput } from './types';

export function donorSchedulesByIdsQueryOptions(ids: string[]) {
  return queryOptions({
    queryKey: ['donorSchedulesByIds', ids],
    queryFn: () => chuteSchedulerApi.fetchDonorSchedulesByIds(ids),
    enabled: ids.length > 0,
  });
}

export const useBulkRevisionUpdate = () => {
  const queryClient = useQueryClient();

  return useReactQueryMutation({
    mutationFn: (input: BulkRevisionUpdateInput) =>
      chuteSchedulerApi.bulkRevisionUpdate(input),
    onSuccess: () => {
      queryClient.invalidateQueries(donorSchedulesByIdsQueryOptions([]));
    },
  });
};
